//@ts-nocheck
import React from 'react'
import styles from './styles.module.css'
import '../style.css';
import { cx } from '@emotion/css'
import { ReferenceComponent } from '../../inlineReference';
import { Radio, Icon } from '../../../../../../../../../index'

export const ReferenceBody = ({ handleDisplayType, singleSelectedRowId, displayType }) => {
  return (singleSelectedRowId.key !== '' &&
    <div className={styles['select-embed-entry-wrapper']}>
      <div className={styles['select-embed-entry-text']}>Select Embed Type: </div>
      <div className={styles['select-embed-entry-buttons']}>
        <Radio
          name="Block"
          value="Block"
          checked={displayType === 'block'}
          text={
            <div className={'entry-modal-radio-wrapper' + (displayType === 'block' ? ' entry-modal-radio-active' : '')}>
              <div>Block</div>
            </div>
          }
          onClick={() => handleDisplayType('block')}
          testId={'embed-as-block'}
        />
        <Radio
          name="Inline"
          value="Inline"
          checked={displayType === 'inline'}
          text={
            <div className={'entry-modal-radio-wrapper' + (displayType === 'inline' ? ' entry-modal-radio-active' : '')}>
              <div>Inline</div>
            </div>
          }
          onClick={() => handleDisplayType('inline')}
          testId={'embed-as-inline'}
        />
      </div>
    </div>
  )
}
